module.exports = __webpack_public_path__ + "media/images/oil_and_gas-d657cbbb5f027795819c8154e6918615.png";